import React from 'react';
import { Link } from 'react-router-dom';
import Helmet from '../components/Helmet';
import HeroSlider from '../components/HeroSlider';
import heroSliderData from '../assets/fake-data/hero-slider';
import Section , {SectionTitle , SectionBody} from '../components/Section';
import PolicyCard from '../components/PolicyCard';
import policy from '../assets/fake-data/policy';
import Grid from '../components/Grid';
import productData from '../assets/fake-data/products';
import ProductCard from '../components/ProductCard';
import banner from '../assets/images/banner.png';



const Home = () => {
    return (
        <Helmet title="Home">
              {/*hero slider*/}
              <HeroSlider data={heroSliderData} control={true} auto={true} timeOut={5000} />
              {/* end hero slider */}
      
               {/* policy section  */}
               <Section>
                   <SectionBody>
                       <Grid
                           col={4}
                           mdCol={2}
                           smCol={1}
                           gap={20}
                       >
                           {
                           policy.map((item , index) => <Link key={index} to="/policy">
                                    <PolicyCard
                                        name={item.name}
                                        description={item.description}
                                        icon={item.icon}
                                    />
                                </Link>)

                           }
                       </Grid>
                       
                   </SectionBody>
               </Section>

               {/* end policy section */}

               {/* best sellings section */}
                
                <Section>
                    <SectionTitle>
                          <h3 className="main-title">Products</h3>
                    </SectionTitle>
                    <SectionBody>
                    <Grid
                           col={4}
                           mdCol={2}
                           smCol={1}
                           gap={20}
                    >
                        {
                            productData.getProducts(4).map((item ,index)=> (
                                <ProductCard 
                                    key={index}
                                    img01={item.image01}
                                    img02={item.image02}
                                    name={item.title}
                                    price={Number(item.price)}
                                    slug={item.slug}
                                />  
                            ))
                        }

                    </Grid>

                    </SectionBody>
               </Section>
               {/* end best sellings section */}

               {/* new arrival section */}
               <Section>
                    <SectionTitle>
                          <h3 className="main-title">Sales Products</h3>
                    </SectionTitle>
                    <SectionBody>
                    <Grid
                           col={4}
                           mdCol={2}
                           smCol={1}
                           gap={20}
                    >
                        {
                            productData.getProducts(8).map((item ,index)=> (
                                <ProductCard 
                                    key={index}
                                    img01={item.image01}
                                    img02={item.image02}
                                    name={item.title}
                                    price={Number(item.price)}
                                    slug={item.slug}
                                />  
                            ))
                        }

                    </Grid>

                    </SectionBody>
               </Section>

               {/* end arrival section */}

               {/* banner */}
                <Section>
                    <SectionBody>
                        <Link to="/catalog">
                            <img src={banner} alt="" />
                        </Link>
                    </SectionBody>
                </Section>

                {/* popular product section */}
               <Section>
                    <SectionTitle>
                          <h3 className="main-title">Popular Products</h3>
                    </SectionTitle>
                    <SectionBody>
                    <Grid
                           col={4}
                           mdCol={2}
                           smCol={1}
                           gap={20}
                    >
                        {
                            productData.getProducts(12).map((item ,index)=> (
                                <ProductCard 
                                    key={index}
                                    img01={item.image01}
                                    img02={item.image02}
                                    name={item.title}
                                    price={Number(item.price)}
                                    slug={item.slug}
                                />  
                            ))
                        }

                    </Grid>

                    </SectionBody>
               </Section>

               {/* end popular product section */}


               {/* end banner */}
        </Helmet>
    )
}

export default Home


